import React from "react"
import styled, { keyframes } from "styled-components"
import { Link } from "react-router-dom"
import RotatingText from "./RotatingText"

const templateCards = [
  {
    situation: "퇴사 메일",
    preview:
      "오늘 마지막 인사를 드리게 되었습니다. 이곳에서 함께한 시간 동안 많은 것을 배우고 성장할 수 있었습니다. 저는 비록 새로운 길을 선택하게 되었지만, 여기서 얻은 소중한 경험과 인연은 기억에 남을 것입니다.",
    author: "수다스러운 인삼",
    left: "3%",
    rotate: -8,
    delay: 0,
    zIndex: 11
  },
  {
    situation: "감사 인사",
    preview:
      "바쁘신 중에도 시간 내주셔서 정말 감사합니다. 덕분에 많은 도움이 되었습니다. 앞으로도 좋은 인연으로 함께할 수 있기를 바라며, 항상 건강하시고 좋은 일만 가득하시길 진심으로 기원합니다.",
    author: "따뜻한 라떼",
    left: "25%",
    rotate: -2,
    delay: 0.1,
    zIndex: 13
  },
  {
    situation: "입사 인사",
    preview:
      "안녕하세요, 이번에 새로 입사한 김지수입니다. 앞으로 팀에 빠르게 적응하여 좋은 성과를 낼 수 있도록 최선을 다하겠습니다. 부족한 점이 있더라도 따뜻하게 알려주시면 감사하겠습니다.",
    author: "설레는 새싹",
    left: "47%",
    rotate: 5,
    delay: 0.2,
    zIndex: 12
  },
  {
    situation: "작업전달",
    preview:
      "OO님 안녕하세요. OOO입니다. 늦은 시간 메일 송신 드려 양해 부탁드립니다. 작성하여 메일 송부드리려 했었으나 지속인 일정으로 완료하지 못하였습니다. 퇴근 후 작성을 위해 장비를 가져왔으나 원활하지 않아 파일이 열리지 않았습니다.",
    author: "빠른 토끼",
    left: "69%",
    rotate: 12,
    delay: 0.3,
    zIndex: 10
  }
]

function Header() {
  return (
    <HeroSection>
      <HeroContent>
        <Subtext>상황에 맞는 말, 고민하지 말고 찾아보세요</Subtext>
        <Headline>
          <HeadlineInner>
            <RotatingText />
            <span>뭐라고 할까</span>
          </HeadlineInner>
        </Headline>

        <FolderStage>
          {templateCards.map((card, i) => (
            <CardOuter
              key={i}
              $left={card.left}
              $delay={card.delay}
              $zIndex={card.zIndex}
            >
              <TemplateCard $rotate={card.rotate}>
                <CardInner>
                  <CardTitle>
                    이렇게 <strong>{card.situation}</strong>
                  </CardTitle>
                  <CardBody>{card.preview}</CardBody>
                </CardInner>
                <CardFooter>
                  <span>from. {card.author}</span>
                </CardFooter>
              </TemplateCard>
            </CardOuter>
          ))}

          <FolderFront to="/templates">
            <FolderSearchInner>
              <FolderSearchIcon>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#C0C0C8"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </FolderSearchIcon>
              <FolderSearchText>
                어떤 상황의 문구가 필요하신가요?
              </FolderSearchText>
              <SearchButton>검색</SearchButton>
            </FolderSearchInner>
          </FolderFront>

          <FolderShadow />
        </FolderStage>
      </HeroContent>
    </HeroSection>
  )
}

const slideUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

const pickMe = keyframes`
  0%, 100% { transform: translateY(0); }
  40% { transform: translateY(-12px); }
  60% { transform: translateY(-4px); }
`

const fadeInUp = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
`

const HeroSection = styled.div`
  background: #f4f4f6;
  padding-top: calc(var(--gnb-height) + 80px);
  padding-bottom: 72px;
  overflow: hidden;

  @media (max-width: 800px) {
    padding-top: calc(var(--gnb-height) + 32px);
    padding-bottom: 8px;
  }
`

const HeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 0 16px;
`

const Headline = styled.h1`
  font-family: "Giants", sans-serif;
  font-size: 3rem;
  line-height: 130%;
  color: #0f0e2c;
  letter-spacing: -0.02em;
  margin-bottom: 0;
  opacity: 0;
  animation: ${fadeInUp} 0.6s ease 0.1s forwards;

  @media (max-width: 800px) {
    font-size: 1.75rem;
    margin-bottom: 16px;
  }
`

const HeadlineInner = styled.span`
  display: flex;
  align-items: baseline;
  gap: 8px;
  justify-content: center;
`

const Subtext = styled.p`
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 0;
  opacity: 0;
  animation: ${fadeInUp} 0.6s ease 0.1s forwards;

  @media (max-width: 800px) {
    font-size: 15px;
    margin-bottom: 4px;
  }
`

const FolderStage = styled.div`
  position: relative;
  max-width: 651px;
  margin: 0 auto 16px;
  aspect-ratio: 651 / 240;
  isolation: isolate;

  @media (max-width: 800px) {
    max-width: 480px;
    margin-bottom: 32px;
  }
`

const CardOuter = styled.div`
  position: absolute;
  left: ${({ $left }) => $left};
  bottom: 24px;
  width: 180px;
  z-index: ${({ $zIndex }) => $zIndex};

  opacity: 0;
  animation: ${slideUp} 0.55s cubic-bezier(0.22, 1, 0.36, 1)
    ${({ $delay }) => 0.15 + $delay}s forwards;

  @media (max-width: 800px) {
    width: 145px;
    bottom: 18px;

    &:nth-child(1) {
      left: 7%;
    }
    &:nth-child(2) {
      left: 33%;
    }
    &:nth-child(3) {
      left: 59%;
    }
    &:nth-child(4) {
      display: none;
    }
  }

  @media (max-width: 480px) {
    width: 110px;
    bottom: 14px;

    &:nth-child(1) {
      left: 5%;
    }
    &:nth-child(2) {
      left: 32%;
    }
    &:nth-child(3) {
      left: 58%;
    }
  }
`

const TemplateCard = styled.div`
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(170deg, #ffffff 0%, #f9f9fb 100%);
  border: 1px solid #ebebeb;
  border-radius: 8px;
  transform: rotate(${({ $rotate }) => $rotate}deg);
  transform-origin: center center;
  overflow: hidden;
  cursor: default;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06),
    0 1px 0 rgba(255, 255, 255, 0.9) inset;

  &:hover {
    animation: ${pickMe} 0.5s ease infinite;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06), 0 16px 40px rgba(0, 0, 0, 0.1),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
    z-index: 10;
  }

  &:active {
    transform: rotate(${({ $rotate }) => $rotate}deg) scale(0.95);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.06),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
    transition: transform 0.1s ease, box-shadow 0.1s ease;
  }
`

const CardInner = styled.div`
  flex: 1;
  padding: 24px 18px 8px;
  text-align: left;
  overflow: hidden;

  @media (max-width: 480px) {
    padding: 18px 8px 4px;
  }
`

const CardTitle = styled.p`
  font-family: "Pretendard", sans-serif;
  font-size: 15px;
  font-weight: 300;
  color: #121212;
  margin-bottom: 8px;
  line-height: 100%;
  text-align: left;

  strong {
    font-weight: 600;
  }

  @media (max-width: 800px) {
    font-size: 12px;
    margin-bottom: 6px;
  }

  @media (max-width: 480px) {
    font-size: 10px;
  }
`

const CardBody = styled.p`
  position: relative;
  font-family: "Pretendard", sans-serif;
  font-size: 9px;
  line-height: 180%;
  font-weight: 400;
  color: #262626;
  word-break: keep-all;
  text-align: left;
  overflow: hidden;
  flex: 1;

  -webkit-mask-image: linear-gradient(
    to bottom,
    #000 0%,
    #000 40%,
    transparent 80%
  );
  mask-image: linear-gradient(to bottom, #000 0%, #000 40%, transparent 80%);

  @media (max-width: 800px) {
    font-size: 8px;
  }

  @media (max-width: 480px) {
    font-size: 7px;
    line-height: 170%;
  }
`

const CardFooter = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 18px;
  border-top: 1px solid #ebebeb;
  text-align: left;

  span {
    font-family: "Pretendard", sans-serif;
    font-size: 7.5px;
    font-weight: 400;
    color: #c5c5c5;
    line-height: 100%;
  }

  @media (max-width: 480px) {
    padding: 5px 10px;
    span {
      font-size: 6px;
    }
  }
`

const glassStyles = `
  background: linear-gradient(
    165deg,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0.4) 40%,
    rgba(242, 242, 248, 0.5) 70%,
    rgba(255, 255, 255, 0.6) 100%
  );
  backdrop-filter: blur(20px) saturate(1.4);
  -webkit-backdrop-filter: blur(20px) saturate(1.4);
  border: 1.25px solid rgba(255, 255, 255, 0.75);
  border-radius: 14px;

  @media (max-width: 800px) { border-radius: 12px; }
  @media (max-width: 480px) { border-radius: 10px; }
`

const FolderFront = styled(Link)`
  display: block;
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  left: -0.5%;
  bottom: 0;
  width: 100%;
  height: 24%;
  z-index: 14;
  ${glassStyles}

  @media (max-width: 800px) {
    left: 0;
    height: 32%;
  }

  @media (max-width: 480px) {
    height: 38%;
  }

  transition: box-shadow 0.25s ease, border-color 0.25s ease;

  box-shadow: 0 2px 0 rgba(255, 255, 255, 0.95) inset,
    0 -1px 0 rgba(0, 0, 0, 0.03) inset, 0 8px 32px rgba(0, 0, 0, 0.07),
    0 1px 3px rgba(0, 0, 0, 0.04);

  &:hover {
    border-color: rgba(85, 81, 255, 0.4);
    box-shadow: 0 2px 0 rgba(255, 255, 255, 0.95) inset,
      0 -1px 0 rgba(0, 0, 0, 0.03) inset, 0 8px 32px rgba(85, 81, 255, 0.1),
      0 0 0 3px rgba(85, 81, 255, 0.08);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 35%;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 14px 14px 0 0;
    pointer-events: none;

    @media (max-width: 800px) {
      border-radius: 12px 12px 0 0;
    }
    @media (max-width: 480px) {
      border-radius: 10px 10px 0 0;
    }
  }
`

const FolderSearchInner = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 8px 0 28px;
  gap: 12px;

  @media (max-width: 480px) {
    padding: 0 6px 0 18px;
    gap: 8px;
  }
`

const FolderSearchIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`

const FolderSearchText = styled.span`
  flex: 1;
  font-size: 14px;
  color: #9ca3af;
  text-align: left;
  letter-spacing: -0.01em;

  @media (max-width: 480px) {
    font-size: 12px;
  }
`

const SearchButton = styled.span`
  flex-shrink: 0;
  padding: 12px 28px;
  background: #0f0e2c;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 12px;
  transition: background 0.2s ease;

  ${FolderFront}:hover & {
    background: #1a1950;
  }

  @media (max-width: 800px) {
    padding: 8px 20px;
    font-size: 13px;
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    padding: 8px 18px;
    font-size: 12px;
    border-radius: 8px;
  }
`

const FolderShadow = styled.div`
  position: absolute;
  left: 13.4%;
  bottom: -3%;
  width: 71.8%;
  height: 4.9%;
  background: #b5b5b5;
  opacity: 0.45;
  filter: blur(17px);
  border-radius: 50%;
  z-index: 0;
`

export default Header
